<template>
  <v-container fluid>
      <v-layout row wrap>

          <v-flex xs10 sm5 offset-xs1 offset-sm1 d-flex align-center>
              <p class="black--text headline mb-0">Jornadas</p>
          </v-flex>

      </v-layout>
      <v-layout row wrap mt-2 v-if="currentIframeTournament">
          <v-flex xs10 offset-xs1>
              <v-tabs v-model="active" light>
                  <v-tabs-bar  class="transparent" left>
                  <v-tabs-slider color="black"></v-tabs-slider>
                  <v-tabs-item
                      class="tab-item-black"
                      v-for="(set, i) in currentIframeTournament.sets"
                      :key="'set' + i"
                      :href="'#set' + i"
                  >
                      <div>
                          <p class="subheading mb-0">{{ dayFormat(set.start_date) }}</p>
                          <span>{{(set.type == "regular" ? "j"+(i+1)+" " :"" )+ set.type }}</span>
                      </div>
                  </v-tabs-item>
                  </v-tabs-bar>
                  <v-tabs-items>
                      <v-tabs-content v-for="(set, i) in currentIframeTournament.sets"
                        :key="'set' + i"
                        :id="'set' + i">
                          <v-container fluid class="mt-3" grid-list-xs>
                              <v-layout row wrap>
                                  <v-flex xs12 mb-3>
                                      <p class="subheading">Partidos</p>
                                  </v-flex>
                                  <div class="mb-4"   v-for="(match, i) in set.matches">
                                    <iframe-match-row
                                    :match="match"
                                    :disabled="true"
                                    >
                                  </iframe-match-row>
                                  </div>


                              </v-layout>
                          </v-container>
                      </v-tabs-content>
                  </v-tabs-items>
              </v-tabs>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import IframeMatchRow from './iframeMatchRow'


export default {
    name: 'IframeCalendar',
    components: {
      IframeMatchRow
    },
    data() {
        return {
          active: 'set0'

        }

    },
    computed:{
      ...mapGetters([
        "currentIframeTournament"
      ])
    },
    methods: {
      ...mapActions([
      ]),
      dayFormat(date) {
        var localLocale = moment(date);
        moment.locale('es');
        localLocale.locale(false);
          return localLocale.format('DD MMM').toUpperCase()
      }
    },
    mounted() {

    },
    created() {

    }
}

</script>

<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/iframe/iframeCalendar.vue